import { Button, Dropdown, Input, Menu, Modal, Select, Typography } from 'antd'
import axios from 'axios'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { QrReader } from 'react-qr-reader'
import { POST } from '../../utils/apis'
import { constraints } from '../../utils/constants'
import { assignMessage, checkSelectOption, errorMessage, /* getAllUserData, */ provisionCalculate } from '../../utils/helpers'

const { Option } = Select
const { Title } = Typography

const AcceptGiftCards = (props) => {
    const { user, language, userActions, selectedLanguage } = props
    const [visible, setVisible] = useState(false)
    const [visibleQR, setVisibleQR] = useState(false)
    const [confirmLoading, setConfirmLoading] = useState(false)
    const [loading, setLoading] = useState(false)
    const [lottery, setLottery] = useState('')
    const [QRCode, setQRCode] = useState(null)
    const [giftCardDetail, setGiftCardDetail] = useState({})
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [isPrizeInput, setPrizeInput] = useState(false)
    const [updatedPrize, setUpdatedPrize] = useState(0)
    const selectAmount = [5, 10, 15, 20, 25, 30, 40, 50, 60, 70, 80, 90, 100]
    // useEffect(() => {
    //     getAllUserData(user?._id, userActions)
    // }, [])

    useEffect(() => {
        if (QRCode && !loading) {
            handleOk(QRCode)
        }
    }, [QRCode])

    const menu = (
        <Menu>
            <Menu.Item onClick={() => setVisible(true)} key='1'>{selectedLanguage?.button_VerifyByCode}</Menu.Item>
            <Menu.Item onClick={() => setVisibleQR(true)} key='2'>{selectedLanguage?.button_VerifyByQrCode}</Menu.Item>
        </Menu>
    )

    const handleOk = (code = null) => {
        setConfirmLoading(true)
        setLoading(true)

        axios.post(POST.VERIFY_GIFT_CARDS, { giftCardCode: lottery || code, userId: user?._id, userType: user?.userType })
            .then((res) => {
                const { data } = res
                if (data?.success) {
                    setGiftCardDetail(data?.data)
                    handleCancel()
                    setVisible(false)
                    setQRCode(null)
                    setVisibleQR(false)
                    setConfirmLoading(false)
                }
                else {
                    errorMessage(assignMessage(data?.message, language?.language))
                }
                setTimeout(() => {
                    setLoading(false)
                }, 500)
            })
            .catch((e) => {
                console.log('e ', e)
                setVisible(false)
                setConfirmLoading(false)
                setLoading(false)
                errorMessage(assignMessage(e?.message, language?.language))
            })

    }

    const handleCancel = () => {
        setVisible(false)
        setVisibleQR(false)
        showModal1()
        setLottery('')
    }
    const handleCancel2 = () => {
        setVisible(false)
        setVisibleQR(false)
        setLottery('')
    }

    const showModal1 = () => {
        setIsModalVisible(true)
    }

    const handlelotteryInput = (e) => {

        let value = e?.target?.value?.replace(/ /g, '')
        let event = e?.nativeEvent?.data

        if (event && ((value?.length === 3 || value?.length === 7) || (lottery?.length === 3 || lottery.length === 7))) {
            if (lottery?.length === 3 || lottery.length === 7) {
                value = `${lottery}-${event}`
            }
            else {
                value = `${value}-`
            }
        }
        setLottery(value)
    }
    const updateGiftCardPrize = () => {
        setLoading(true)
        let obj = {
            amount: Number(updatedPrize) + Number(provisionCalculate(Number(updatedPrize))) || 0,
            isAdmin: giftCardDetail.isAdmin,
            guestId: user?._id,
            giftCardCode: giftCardDetail?.giftCardCode,
            _id: giftCardDetail._id,
            totalProvision: Number(provisionCalculate(Number(updatedPrize)))
        }

        axios.post(POST?.CHANGE_PRIZE_OF_GIFT_CARDS, obj)
            .then((res) => {
                const { data } = res
                if (data?.success) {
                    setGiftCardDetail({})
                    setIsModalVisible(false)
                    window.location.href = data?.redirectUrl
                    return
                }
                else {
                    errorMessage(assignMessage(data?.message, language?.language))
                }
                setTimeout(() => {
                    setLoading(false)
                }, 500)
            })
            .catch((e) => {
                console.log('e ', e)
                setLoading(false)
                errorMessage(assignMessage(e?.message, language?.language))
            })
    }

    const scanQr = async qr => {
        let code = qr?.text

        if (code) {
            setQRCode(code)
        }
    }

    return (
        <div>
            <Dropdown overlay={menu} placement='bottomLeft'>
                <Button
                    style={{ height: '40px', width: '140px', margin: '2px', marginTop: '10px' }}
                    className='addproduct-text'
                    type='primary'
                >
                    {selectedLanguage?.button_VerifyGiftCards}
                </Button>
            </Dropdown>
            <Modal
                // title={<center>
                //     <Title level={4} style={{ color: '#ec671b' }}>{selectedLanguage?.title_GiftCard}</Title>
                // </center>}
                className='pop-info-modal'
                style={{ top: '10px' }}
                open={visible}
                onOk={handleOk}
                confirmLoading={confirmLoading}
                onCancel={handleCancel2}
                footer={[
                    <Button key='back' onClick={handleCancel2}
                        style={{ height: '40px', width: '100px', marginTop: '10px' }}
                        className='cancel-btn'>
                        {selectedLanguage?.Cancel}
                    </Button>,
                    <Button
                        key='ok'
                        onClick={handleOk}
                        disabled={lottery?.length !== 11}
                        loading={loading}
                        style={{ height: '40px', width: '150px', marginTop: '10px' }}
                        className='cancel-btn'
                        type='primary'
                    >
                        {selectedLanguage?.button_VerifyGiftCards}
                    </Button>
                ]}
            >
                <p className='new-p-question'>{selectedLanguage?.title_GiftCard}</p>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <h4 style={{ color: '#ec671b' }}>{selectedLanguage?.title_EnteryourGiftCardnumber}</h4>
                    <div className='form-input-single-input'>
                        <Input
                            className='form-input-new-style'
                            autoFocus
                            required
                            maxLength={11}
                            value={lottery}
                            onChange={handlelotteryInput}
                            placeholder='e.g: 456-786-ab6'
                        />
                    </div>
                </div>
            </Modal>

            <Modal
                // title={<center>
                //     <Title level={4} style={{ color: '#ec671b' }}>{selectedLanguage?.ActivateQR}</Title>
                // </center>}
                open={visibleQR}
                onOk={handleOk}
                confirmLoading={confirmLoading}
                onCancel={handleCancel2}
                className='pop-info-modal'
                style={{ top: '10px' }}
                footer={[
                    <Button key='back' onClick={handleCancel2}
                        style={{ height: '40px', width: '100px', marginTop: '10px' }}
                        className='cancel-btn'>
                        {selectedLanguage?.Cancel}
                    </Button>
                ]}
            >
                <p className='new-p-question'>{selectedLanguage?.ActivateQR}</p>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <h4 style={{ color: '#ec671b' }}>{selectedLanguage?.ScanyourQr}</h4>
                    <QrReader
                        delay={1000}
                        onError={e => errorMessage(selectedLanguage?.WebCamNotFound)}
                        constraints={constraints}
                        // constraints={{facingMode: 'environment'}}
                        onResult={scanQr}
                        style={{ width: '100%' }}
                    />
                </div>
            </Modal >
            <Modal
                title={<center>
                    <Title level={4}>{selectedLanguage?.title_GiftCardDetails}</Title>
                </center>}
                open={isModalVisible}
                confirmLoading={confirmLoading}
                onCancel={() => { setPrizeInput(false); setIsModalVisible(false) }}
                footer={[
                    <>
                        {
                            giftCardDetail?.amount <= 0 && giftCardDetail?.isAdmin == true === !giftCardDetail?.guestId
                                ?
                                <>
                                    <Button key='back' onClick={() => setIsModalVisible(false)} className='form-input'>
                                        {selectedLanguage?.Cancel}
                                    </Button>
                                    {
                                        !isPrizeInput ?
                                            <Button loading={loading} key='backs' onClick={() => {
                                                setPrizeInput(true)
                                            }} className='form-input'>
                                                {selectedLanguage?.button_UpdateGiftCardPrize}
                                            </Button>
                                            :
                                            <Button loading={loading} key='backs' onClick={() => {
                                                updateGiftCardPrize(giftCardDetail)
                                            }} className='form-input'>
                                                {selectedLanguage?.Update}
                                            </Button>
                                    }
                                </>
                                :
                                <Button key='back' onClick={() => setIsModalVisible(false)} className='form-input'>
                                    {selectedLanguage?.Cancel}
                                </Button>
                        }
                    </>
                ]}
            >
                {
                    !isPrizeInput ?
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <ul>
                                <li><b>{selectedLanguage?.Amount}: </b>{giftCardDetail?.amount ? giftCardDetail?.amount : '0'} </li>
                                <li><b>{selectedLanguage?.CreatedAt}: </b>{giftCardDetail?.created ? moment(giftCardDetail?.created)?.format('YYYY-MM-DD') : '-------'} </li>
                                <li><b>{selectedLanguage?.Code}: </b>{giftCardDetail?.giftCardCode ? giftCardDetail?.giftCardCode : '-------'}</li>
                                <li><b>{selectedLanguage?.title_Admin}: </b>{giftCardDetail?.giftCardCode ? `${giftCardDetail?.isAdmin}` : '-------'}</li>
                                <li><b>{selectedLanguage?.title_SeriesName}:</b> {giftCardDetail?.seriesName ? giftCardDetail?.seriesName : '-------'}</li>
                            </ul>
                        </div> :
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <ul>
                                <li><b>{selectedLanguage?.CreatedAt}: </b>{giftCardDetail?.created ? moment(giftCardDetail?.created)?.format('YYYY-MM-DD') : '-------'} </li>
                                <li><b>{selectedLanguage?.Code}: </b>{giftCardDetail?.giftCardCode ? giftCardDetail?.giftCardCode : '-------'}</li>
                                <li><b>{selectedLanguage?.title_Admin}: </b>{giftCardDetail?.giftCardCode ? `${giftCardDetail?.isAdmin}` : '-------'}</li>
                                <li><b>{selectedLanguage?.title_SeriesName}:</b> {giftCardDetail?.seriesName ? giftCardDetail?.seriesName : '-------'}</li>
                                {selectedLanguage?.Amount}:
                                <Select
                                    style={{ width: '100%' }}
                                    showArrow
                                    allowClear
                                    className='form-input'
                                    placeholder={selectedLanguage?.placeholder_PleaseSelectAmount}
                                    onSelect={setUpdatedPrize}
                                    showSearch
                                    optionFilterProp='children'
                                    filterOption={checkSelectOption}
                                >
                                    {selectAmount?.map((v, i) => <Option value={v} key={i}>{v}</Option>)}
                                </Select>
                            </ul>
                        </div>
                }
            </Modal>
        </div >
    )
}

export default AcceptGiftCards